import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './FactAboutScaffoldingSection1.css';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import { FactsAboutScaffolding } from '../../../api';
import { Utils } from '../../../utilities/Utils';
import DateBox from '../../molecules/labelandtextbox/DateBox';

interface FactsAboutScaffoldingProp {
    factAboutScaffolding: FactsAboutScaffolding;
    setFactAboutScaffolding?: React.Dispatch<React.SetStateAction<FactsAboutScaffolding | undefined>>;
    onUpdate: (newObject: FactsAboutScaffolding) => void;
}

const FactAboutScaffoldingSection1: React.FC<FactsAboutScaffoldingProp> = (props) => {   

    const handleChange = (updatedData: Partial<FactsAboutScaffolding>) => {
        const newObject = { ...props.factAboutScaffolding, ...updatedData };
        props.setFactAboutScaffolding?.(newObject);
        props.onUpdate(newObject);
    };

    const handleScaffoldingSelection = (
        selectedOption: keyof Pick<
            FactsAboutScaffolding,
            | 'typeExaminationCertificateOrAssemblyInstructionsForSystemScaffolding'
            | 'typicalCasesForPipesAndCouplingSettings'
            | 'typeInspectionCertificateOrTypeCaseWithSupplementarySimplifiedCalculations'
            | 'specialCalculationsInTheIndividualCase'
        >
    ) => {
        handleChange({
            typeExaminationCertificateOrAssemblyInstructionsForSystemScaffolding:
                selectedOption === 'typeExaminationCertificateOrAssemblyInstructionsForSystemScaffolding',
            typicalCasesForPipesAndCouplingSettings:
                selectedOption === 'typicalCasesForPipesAndCouplingSettings',
            typeInspectionCertificateOrTypeCaseWithSupplementarySimplifiedCalculations:
                selectedOption === 'typeInspectionCertificateOrTypeCaseWithSupplementarySimplifiedCalculations',
            specialCalculationsInTheIndividualCase:
                selectedOption === 'specialCalculationsInTheIndividualCase',
        });
    };

    return (
        <div>
            <Col className=''>
                <Row>
                    <Col xs={12}>
                        <LabelAndTextBox title='BESTÄLLARE' remark={props.factAboutScaffolding.customerName}
                            onChange={(value) => handleChange({ customerName: value })} />
                    </Col>
                    <Col xs={12}>
                        <LabelAndTextBox title='KUNDS KONTAKT-PERSON/TEL' remark={props.factAboutScaffolding.customerContactNamePhone}
                            onChange={(value) => handleChange({ customerContactNamePhone: value })} />
                    </Col>
                    <Col xs={12}>
                        <LabelAndTextBox title='STÄLLNINGS-ENTREPRENÖR' remark={props.factAboutScaffolding.scaffoldingCompany}
                            onChange={(value) => handleChange({ scaffoldingCompany: value })} />
                    </Col>
                    <Col xs={12}>
                        <LabelAndTextBox title='KONTAKT-PERSON/TEL' remark={props.factAboutScaffolding.contactNameAndPhoneNumberSTB}
                            onChange={(value) => handleChange({ contactNameAndPhoneNumberSTB: value })} />
                    </Col>
                    <Col xs={12}>
                        <LabelAndTextBox title='ARBETSPLATS' remark={props.factAboutScaffolding.projectAddress}
                            onChange={(value) => handleChange({ projectAddress: value })} />
                    </Col>
                    <Col xs={12}>
                        <LabelAndTextBox title='TYP AV STÄLLNING' remark={props.factAboutScaffolding.typeOfScaffolding}
                            onChange={(value) => handleChange({ typeOfScaffolding: value })} />
                    </Col>
                    <Col xs={12}>
                        <LabelAndTextBox title='STÄLLNING AVSEDD FÖR TYP AV ARBETE' remark={props.factAboutScaffolding.scaffoldingIntendedForTypeOfWork}
                            onChange={(value) => handleChange({ scaffoldingIntendedForTypeOfWork: value })} />
                    </Col>
                </Row>
            </Col>
            <Row>
                <Col xs={12} md={6} lg={6}>
                    <div className="input-sections">
                        <div className="input-section-2">
                            <label>STÄLLNINGSNUMMER</label>
                            <input className='fs-5' type="number" defaultValue={props.factAboutScaffolding.scaffoldingNumber}
                                onChange={(event) => handleChange({ scaffoldingNumber: parseInt(event.target.value) })} />
                        </div>
                        <div className="input-section-2">
                            <label>LASTKLASS ENL. SS-EN 12811-1:2004</label>
                            <input className='fs-5' type="number" defaultValue={props.factAboutScaffolding.loadClass}
                                onChange={(event) => handleChange({ loadClass: parseInt(event.target.value) })} />
                        </div>
                        <div className="input-section-2">
                            <label>MAX LAST KG/m²</label>
                            <input className='fs-5' type="number" defaultValue={props.factAboutScaffolding.maxLoad}
                                onChange={(event) => handleChange({ maxLoad: parseInt(event.target.value) })} />
                        </div>
                        <div className="input-section-2">
                            <label>ANTAL INPLANKADE BOMLAG (ST)</label>
                            <input className='fs-5' type="number" defaultValue={props.factAboutScaffolding.numberOfPlankedBeams}
                                onChange={(event) => handleChange({ numberOfPlankedBeams: parseInt(event.target.value) })} />
                        </div>
                        <div className="input-section-2">
                            <label>ANTAL SAMTIDIGT BELASTADE BOMLAG (ST)</label>
                            <input className='fs-5' type="number" defaultValue={props.factAboutScaffolding.numberOfBeamsBurdenedAtTheSameTime}
                                onChange={(event) => handleChange({ numberOfBeamsBurdenedAtTheSameTime: parseInt(event.target.value) })} />
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={4} lg={6}>
                    <div className="important-section">
                        <h1>VIKTIGT!</h1>
                        <p>
                            •Ställningsentreprenören utför egenkontrollen <br />
                            av ställningen innan den överlämnas till beställaren<br /><br />
                            •Handlingar som fordras enligt AFS 2023:11 8 kap 34 § skall <br />
                            överlämnas till beställaren och finns tillgänglig genom nedan QRkod.<br /><br />
                            •Ställningen skall före användning och fortlöpande kontrolleras <br />
                            under användningstiden av beställaren, AFS 2023:11, 8 kap 37 §.<br /><br />
                            •Ingrepp i ställningen får enbart utföras av personal med<br />
                            erforderlig utbildning, AFS 2023:11, 8 kap 24 § och efter medgivande av uthyraren.<br /><br />
                            •Innan ställningen ställs till uthyraren förfogande för<br />
                            nedmontering skall ställningen vara väl avstädad, rengjord och fri från snö och is.
                        </p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} lg={12} className='align-items-center'>
                    <div className="input-section-3 mt-4">
                        <label>1. UPPFÖRD ENL. TYPKONTROLLINTYG ELLER
                            MONTERINGSINSTRUKTIONER FÖR SYSTEMSTÄLLNING</label>
                        <input
                            type="checkbox"
                            checked={props.factAboutScaffolding.typeExaminationCertificateOrAssemblyInstructionsForSystemScaffolding ?? false}
                            onChange={() => handleScaffoldingSelection('typeExaminationCertificateOrAssemblyInstructionsForSystemScaffolding')}
                        />
                    </div>
                    <div className="input-section-3">
                        <label>2. UPPFÖR ENL. TYPFALL FÖR RÖR- OCH
                            KOPPLINGSTÄLLNINGAR</label>
                        <input
                            type="checkbox"
                            checked={props.factAboutScaffolding.typicalCasesForPipesAndCouplingSettings ?? false}
                            onChange={() => handleScaffoldingSelection('typicalCasesForPipesAndCouplingSettings')}
                        />
                    </div>
                    <div className="input-section-3">
                        <label>3. UPPFÖR ENL. TYPKONTROLLINTYG ELLER
                            TYPFALL MEDKOMPLETTERANDE FÖRENKLADE
                            BERÄKINGAR</label>
                        <input
                            type="checkbox"
                            checked={props.factAboutScaffolding.typeInspectionCertificateOrTypeCaseWithSupplementarySimplifiedCalculations ?? false}
                            onChange={() => handleScaffoldingSelection('typeInspectionCertificateOrTypeCaseWithSupplementarySimplifiedCalculations')}
                        />
                    </div>
                    <div className="input-section-3">
                        <label>4. UPPFÖRD ENL. SÄRSKILDA BERÄKNINGAR I
                            DET ENSKILDA FALLET</label>
                        <input
                            type="checkbox"
                            checked={props.factAboutScaffolding.specialCalculationsInTheIndividualCase ?? false}
                            onChange={() => handleScaffoldingSelection('specialCalculationsInTheIndividualCase')}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <LabelAndTextBox title='EGENKONTROLL UTFÖRD OCH GODKÄND AV' remark={props.factAboutScaffolding.selfControlCarriedOutAndApprovedBy}
                        onChange={(value) => handleChange({ selfControlCarriedOutAndApprovedBy: value })} />
                    <p>Montageledare/Ställningsbyggare</p>
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='AVSYNAD OCH GODKÄND AV' remark={props.factAboutScaffolding.reviewedAndApprovedBy}
                        onChange={(value) => handleChange({ reviewedAndApprovedBy: value })} />
                    <p>Beställare/Ombud</p>
                </Col>
                <Col xs={12}>
                    <div className='d-flex align-items-center justify-content-between'>
                        <label>STÄLLNING ÖVERLÄMNAD TILL BESTÄLLARE DEN:</label>
                        {!Utils.isDateInitialized(props.factAboutScaffolding.scaffoldingSubmittedOnDate) &&
                            <span>Se QR kod</span>
                        }
                        <DateBox defaultValue={props.factAboutScaffolding.scaffoldingSubmittedOnDate}
                            onChange={(value) => handleChange({ scaffoldingSubmittedOnDate: value.toISOString() })} />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default FactAboutScaffoldingSection1;